import { CodeRepoReviewStatus } from '@amzn/awscat-pattern-library-service-model';

export const codeRepoReviewStatusLabels = new Map([
  [CodeRepoReviewStatus.NotStarted, 'Not Started'],
  [CodeRepoReviewStatus.InProgress, 'In Progress'],
  [CodeRepoReviewStatus.ResolvedSuccessful, 'Resolved Successful'],
  [CodeRepoReviewStatus.ResolvedUnsuccessful, 'Resolved Unsuccessful'],
]);
